module.exports = {
	"_args": [
		[
			"babylon@https://registry.npmjs.org/babylon/-/babylon-6.4.5.tgz",
			"C:\\src\\astexplorer\\node_modules\\babylon6"
		]
	],
	"_from": "babylon@>=6.1.21 <7.0.0",
	"_id": "babylon@6.4.5",
	"_inCache": true,
	"_location": "/babylon6/babylon",
	"_phantomChildren": {},
	"_requested": {
		"name": "babylon",
		"raw": "babylon@https://registry.npmjs.org/babylon/-/babylon-6.4.5.tgz",
		"rawSpec": "https://registry.npmjs.org/babylon/-/babylon-6.4.5.tgz",
		"scope": null,
		"spec": "https://registry.npmjs.org/babylon/-/babylon-6.4.5.tgz",
		"type": "remote"
	},
	"_requiredBy": [
		"/babylon6"
	],
	"_resolved": "https://registry.npmjs.org/babylon/-/babylon-6.4.5.tgz",
	"_shasum": "ba23b94e16c46f4b618e1f2bf99efe384acb498a",
	"_shrinkwrap": null,
	"_spec": "babylon@https://registry.npmjs.org/babylon/-/babylon-6.4.5.tgz",
	"_where": "C:\\src\\astexplorer\\node_modules\\babylon6",
	"author": {
		"email": "sebmck@gmail.com",
		"name": "Sebastian McKenzie"
	},
	"bin": {
		"babylon": "./bin/babylon.js"
	},
	"contributors": [
		{
			"name": "keeyipchan"
		},
		{
			"name": "List of Acorn contributors. Updated before every release."
		},
		{
			"name": "Alistair Braidwood"
		},
		{
			"name": "Andres Suarez"
		},
		{
			"name": "Aparajita Fishman"
		},
		{
			"name": "Arian Stolwijk"
		},
		{
			"name": "Artem Govorov"
		},
		{
			"name": "Brandon Mills"
		},
		{
			"name": "Charles Hughes"
		},
		{
			"name": "Conrad Irwin"
		},
		{
			"name": "David Bonnet"
		},
		{
			"name": "Forbes Lindesay"
		},
		{
			"name": "Gilad Peleg"
		},
		{
			"name": "impinball"
		},
		{
			"name": "Ingvar Stepanyan"
		},
		{
			"name": "Jesse McCarthy"
		},
		{
			"name": "Jiaxing Wang"
		},
		{
			"name": "Joel Kemp"
		},
		{
			"name": "Johannes Herr"
		},
		{
			"name": "Jürg Lehni"
		},
		{
			"name": "Adrian Rakovsky"
		},
		{
			"name": "Kevin Kwok"
		},
		{
			"name": "krator"
		},
		{
			"name": "Marijn Haverbeke"
		},
		{
			"name": "Martin Carlberg"
		},
		{
			"name": "Mathias Bynens"
		},
		{
			"name": "Mathieu 'p01' Henri"
		},
		{
			"name": "Max Schaefer"
		},
		{
			"name": "Max Zerzouri"
		},
		{
			"name": "Mihai Bazon"
		},
		{
			"name": "Mike Rennie"
		},
		{
			"name": "Nick Fitzgerald"
		},
		{
			"name": "Oskar Schöldström"
		},
		{
			"name": "Paul Harper"
		},
		{
			"name": "Peter Rust"
		},
		{
			"name": "PlNG"
		},
		{
			"name": "r-e-d"
		},
		{
			"name": "Rich Harris"
		},
		{
			"name": "Sebastian McKenzie"
		},
		{
			"name": "zsjforcn"
		}
	],
	"dependencies": {
		"babel-runtime": "^5.0.0"
	},
	"description": "A JavaScript parser",
	"devDependencies": {
		"babel-helper-fixtures": "^6.3.13"
	},
	"homepage": "https://babeljs.io/",
	"license": "MIT",
	"main": "index.js",
	"name": "babylon",
	"optionalDependencies": {},
	"readme": "<p align=\"center\">\n  <img alt=\"babylon\" src=\"https://raw.githubusercontent.com/babel/logo/master/babylon.png\" width=\"700\">\n</p>\n\n<p align=\"center\">\n  Babylon is a JavaScript parser used in <a href=\"https://github.com/babel/babel\">Babel</a>.\n</p>\n\n - ES6 enabled by default.\n - Comment attachment.\n - Support for JSX and Flow.\n - Support for experimental language proposals.\n\n## Credits\n\nHeavily based on [acorn](https://github.com/marijnh/acorn) and [acorn-jsx](https://github.com/RReverser/acorn-jsx),\nthanks to the awesome work of [@RReverser](https://github.com/RReverser) and [@marijnh](https://github.com/marijnh).\n\nSignificant diversions are expected to occur in the future such as streaming, EBNF definitions, sweet.js integration, interspacial parsing and more.\n\n## API\n\n### `babylon.parse(code, [options])`\n\n## Options\n\n- **allowImportExportEverywhere**: By default, `import` and `export`\n  declarations can only appear at a program's top level. Setting this\n  option to `true` allows them anywhere where a statement is allowed.\n\n- **allowReturnOutsideFunction**: By default, a return statement at\n  the top level raises an error. Set this to `true` to accept such\n  code.\n\n- **allowSuperOutsideMethod** TODO\n\n- **sourceType**: Indicate the mode the code should be parsed in. Can be\n  either `\"script\"` or `\"module\"`.\n\n- **plugins**: Array containing the plugins that you want to enable.\n\n### Example\n\n```javascript\nrequire(\"babylon\").parse(\"code\", {\n  // parse in strict mode and allow module declarations\n  sourceType: \"module\",\n\n  plugins: [\n    // enable experimental async functions\n    \"asyncFunctions\",\n\n    // enable jsx and flow syntax\n    \"jsx\",\n    \"flow\"\n  ]\n});\n```\n\n### Plugins\n\n - `jsx`\n - `flow`\n - `asyncFunctions`\n - `classConstructorCall`\n - `doExpressions`\n - `trailingFunctionCommas`\n - `objectRestSpread`\n - `decorators`\n - `classProperties`\n - `exportExtensions`\n - `exponentiationOperator`\n - `asyncGenerators`\n - `functionBind`\n - `functionSent`\n",
	"readmeFilename": "README.md",
	"repository": {
		"type": "git",
		"url": "https://github.com/babel/babel/tree/master/packages/babylon"
	},
	"version": "6.4.5"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/babylon6/~/babylon/package.json
 ** module id = ./node_modules/babylon6/node_modules/babylon/package.json
 ** module chunks = 0
 **/